<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "Newsbanner",
  setup() {
    const base = "https://www.gev-versicherung.de/";
    const title = "Zur Newsletter Anmeldung";
    const altText = "Anmeldung Newsletter";
    const link = base + "/service/newsletter/";
    const banner = base + "typo3conf/ext/gev_site_package/Resources/Public/Images/sonstige/NewsBanner.png";
    return { banner, title, altText, link };
  },
});
</script>

<template>
  <section class="u-bg-white u-pad-y-1 u-mar-y-0 o-container__remove">
    <div class="o-container u-pad-y-1">
      <a :href="link" :title="title" target="_self">
        <img :src="banner" alt="altText" />
      </a>
    </div>
  </section>
</template>
